// extracted by mini-css-extract-plugin
export var benefitText = "rightBlock-module--benefitText--WdWWG";
export var benefitValue = "rightBlock-module--benefitValue--fw6qO";
export var btnCTA = "rightBlock-module--btnCTA--0RENO";
export var foot = "rightBlock-module--foot--Mden9";
export var head = "rightBlock-module--head--7u93b";
export var headTitle = "rightBlock-module--headTitle--Btb7g";
export var headValue = "rightBlock-module--headValue--3q9QX";
export var iconButtonRoot = "rightBlock-module--iconButtonRoot--AcPsh";
export var iconDescr = "rightBlock-module--iconDescr--k9MQQ";
export var row = "rightBlock-module--row--De0Lg";
export var wrapper = "rightBlock-module--wrapper--OpQxF";
export var wrapperIcon = "rightBlock-module--wrapperIcon--MWpL3";